export * from "./thirdcode";
export * from "./thirdcode.types";
